import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../../../services/auth.service";
import { RequestService } from "../../../../services/request.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-confirm-request-success",
  templateUrl: "./confirm-request-success.component.html",
  styleUrls: ["./confirm-request.component.css"],
})
export class ConfirmRequestSuccessComponent implements OnInit {
  constructor(
    private _router: Router,
    public _auth: AuthService,
    public _request: RequestService
  ) {}

  ngOnInit(): void {
    if (this._request.request === null) {
      this._router.navigate(["/pages/new-request"]);
    }
  }

  newRequest() {
    this._request.reset();
    this._router.navigate(["/pages/new-request"]);
  }

}
